import React from 'react';
import PropTypes from 'prop-types';
import { Section, Image } from '..';
import './SubpageBanner.scss';

const SubpageBanner = ({
  additionalClass,
  backgroundColor,
  contentBackground,
  image,
  children,
  alt,
}) => (
  <Section
    color={backgroundColor}
    additionalClass={`subpage-banner ${additionalClass}`}
    fullwidth
  >
    <div
      className={
        'subpage-banner__image-container w-container w-container--stick w-container--side-right'
      }
    >
      <div className={'subpage-banner__image'}>
        <Image
          src={image}
          style={{
            objectPosition: 'top center',
          }}
          alt={alt}
        />
      </div>
    </div>
    <div
      className={
        'subpage-banner__content-container w-container w-container--side-left'
      }
    >
      <div
        className={`w-container--left subpage-banner__content subpage-banner__content--${contentBackground}`}
      >
        {children}
      </div>
    </div>
  </Section>
);

SubpageBanner.defaultProps = {
  additionalClass: '',
  children: null,
  backgroundColor: 'white',
  contentBackground: 'mine-shaft',
};

SubpageBanner.propTypes = {
  additionalClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  image: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]).isRequired,
  backgroundColor: PropTypes.string,
  contentBackground: PropTypes.string,
  alt: PropTypes.string,
};

export default SubpageBanner;
